export default "__VITE_ASSET__ByHG8tBU__"